module.exports = __webpack_public_path__ + "img/cost.7ae09ad3.png";